export const fmtDate = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const fmtMoney = (n: number): string =>
  "€" + n.toLocaleString("en-IE");

export const monthsBetween = (a: string, b: string): number => {
  const da = new Date(a);
  const db = new Date(b);
  return (
    (db.getFullYear() - da.getFullYear()) * 12 + (db.getMonth() - da.getMonth())
  );
};

export const initialsOf = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((p) => p[0]!.toUpperCase())
    .slice(0, 2)
    .join("");
